import { clearResults } from "../../redux/store";
import { removeAuth } from "../utils/token/token.util";

export const signOut = () => {
  clearResults();
  removeAuth();
};
